import { useState } from 'react';

import Card from '@material-tailwind/react/Card';
import CardBody from '@material-tailwind/react/CardBody';
import CardFooter from '@material-tailwind/react/CardFooter';
import Input from '@material-tailwind/react/Input';
import Button from '@material-tailwind/react/Button';
import Icon from '@material-tailwind/react/Icon';
import { Heading3, Textarea } from '@material-tailwind/react';
import { supportEmail } from 'routes/userRoutes';
import { useGlobalState } from 'state-pool';

export default function ContactUs() {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const [currentUser] = useGlobalState('currentUser');

    async function onSendClick() {
        let tempError = {};

        if(!subject) {
            tempError['subject'] = 'Please enter a subject';
        }

        if(!message) {
            tempError['message'] = 'Please enter a subject';
        }

        if(tempError && typeof tempError === 'object' && Object.keys(tempError).length > 0) {
            setError(tempError);

            return;
        }

        if (currentUser && subject && message) {
            const body = { "email": currentUser.email, "subject": subject, "message": message }
            if (body) {
                const res = await supportEmail(body);

                if(res && (res.data.statusCode === 0)) setSuccess(true);
            }
        }

    }

    return (
        <Card className="text-left mt-5 bg-primary">
            {!success ? (
                <>
                    <Heading3 color="white" className="font-light text-4xl text-white">Have a question?</Heading3>
                    <div className="h-2" />
                    <CardBody>

                        <div className="mb-4 text-left">
                            <Input
                                outline={false}
                                value={subject}
                                onChange={e => setSubject(e.target.value)}
                                type="text"
                                color="green"
                                placeholder="Subject"
                                size="regular"
                                error={error && error.subject}
                            />
                        </div>

                        <div className="mb-4 mt-10 text-left">
                            <Textarea
                                outline={false}
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                                type="text"
                                color="green"
                                placeholder="Your message"
                                size="regular"
                                error={error && error.message}
                            />
                        </div>

                    </CardBody>
                    <CardFooter>
                        <Button
                            color="green"
                            className="w-full hover:bg-green hover:text-white hover:shadow-xl hover:pr-2"
                            buttonType="outline"
                            size="lg"
                            ripple="dark"
                            onClick={onSendClick}
                        >
                            Send
                            <Icon name="arrow_forward" size="sm" />
                        </Button>
                    </CardFooter>
                </>
            ) : (
                <div className="w-full h-full flex flex-col items-center justify-center p-4">
                    <h3 className="text-4xl text-center font-bold text-white">Your email has been sent successfully</h3>
                    <p className="text-sm text-center font-light py-4 text-white">We will get back to you within 24 hours</p>
                    <Button
                        color="green"
                        className="w-full hover:bg-green hover:text-white hover:shadow-xl hover:pr-2 mt-4"
                        buttonType="outline"
                        size="lg"
                        ripple="dark"
                        onClick={() => setSuccess(false)}
                    >
                        Send another
                        <Icon name="arrow_forward" size="sm" />
                    </Button>
                </div>
            )}
        </Card>
    );
}